export class CodeValueMessageArg {
    code: string;
    value: string;
}
